class EratecInhalt extends HTMLElement {
  connectedCallback() {
    const inhalt = this.querySelector('[data-er-text]');
    const ziel = this.querySelector('[data-er-toc]');
    const mindest = Number(this.dataset.mindest || 3);
    if (!inhalt || !ziel) return;

    const ueberschriften = [...inhalt.querySelectorAll('h2')];
    if (ueberschriften.length < mindest) return;

    const liste = document.createElement('ul');
    liste.className = 'eratec-recht__toc-liste';

    ueberschriften.forEach((h, i) => {
      if (!h.id) h.id = `eratec-abschnitt-${i + 1}`;
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.className = 'eratec-recht__toc-link';
      a.href = `#${h.id}`;
      a.textContent = h.textContent.trim();
      li.append(a);
      liste.append(li);
    });

    const titel = document.createElement('h2');
    titel.className = 'eratec-recht__toc-titel';
    titel.textContent = this.dataset.titel || '';

    ziel.append(titel, liste);
    ziel.hidden = false;

    // Mitlaufende Markierung. rootMargin schneidet das obere Drittel weg,
    // damit der Abschnitt erst als "hier" gilt, wenn er wirklich oben steht.
    if (!('IntersectionObserver' in window)) return;
    const links = new Map(ueberschriften.map((h, i) => [h.id, liste.children[i].firstChild]));
    const beobachter = new IntersectionObserver(
      (eintraege) => {
        for (const e of eintraege) {
          if (!e.isIntersecting) continue;
          for (const a of links.values()) a.removeAttribute('aria-current');
          links.get(e.target.id)?.setAttribute('aria-current', 'true');
        }
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    ueberschriften.forEach((h) => beobachter.observe(h));
  }
}

if (!customElements.get('eratec-inhalt')) {
  customElements.define('eratec-inhalt', EratecInhalt);
}
